"use client";

import { useAuthenticationStore } from "@/core/stores/auth";
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { useEffect, useState } from "react";
import AccordeonBasic from '../AccorderonBasic';
import { sendEmail } from '@/actions/authentication';
import Button from '../ui/Button';

const LoginForm = ({ apiUrl, setShowCodeInput, onSubmit, hideReferralInput = false, isLoading }: {
  apiUrl?: string, setShowCodeInput: any, onSubmit?: () => void, hideReferralInput?: boolean,
  isLoading?: boolean
}) => {
  const { email, setEmail } = useAuthenticationStore()
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const { params: { referralCode } } = useSetSearchParams()

  useEffect(() => {
    if (referralCode) {
      setCode(referralCode)
    }
  }, [referralCode])

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmitForm = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError('Email is wrong, please change it.')
      return
    } else {
      setError('')
    }

    setLoading(true)
    const body: any = {
      email: email
    }

    if (code) {
      body.referralCode = code
    }
    const res = await sendEmail(body)

    const { result, response } = JSON.parse(res)

    if (response.status === 200) {
      setShowCodeInput(true)
      if (onSubmit) {
        onSubmit()
      }
    } else {

      setError(result.message)
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmitForm} className="flex flex-col gap-2">
      <div>
        <label
          htmlFor="email"
          className="mb-2 block text-sm font-medium text-gray-900 "
        >
          Enter your Email
        </label>
        <input
          type="text"
          id="email"
          name="email"
          value={email}
          onChange={((e) => setEmail(e.target.value))}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-gray-600 focus:ring-0      "
          placeholder="name@example.com"
        />
      </div>
      {!hideReferralInput && <div className='mt-2'>
        <AccordeonBasic
          reverseCheveron
          title={<label
            htmlFor="referral"
            className="mb-2 block text-sm font-medium text-indigo-500 "
          >
            If you have referral code enter here
          </label>}>
          <input
            type="text"
            id="referral"
            name="referral"
            value={code}
            onChange={((e) => setCode(e.target.value))}
            className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-gray-600 focus:ring-0      "
            placeholder="Your referral code"
          />
        </AccordeonBasic>

      </div>}
      <p className=" text-sm font-normal text-gray-500 pb-2">
        We will send you an Email with a verification code.
      </p>
      <Button
        isLoading={(loading || isLoading)}
        radius='rounded-full'
        color='secondary'
        type="submit"
        disabled={loading || isLoading}
        className={`${loading || isLoading ? 'bg-gray-550/70' : ''}
                 w-full   text-sm text-white`}
      >
        Send verification code
      </Button>
      {error && <p className="text-rose-500 text-sm">{error}</p>}
    </form>
  );
};

export default LoginForm;
